if (!customElements.get("video-component")) {
  class e extends HTMLElement {
    constructor() {
      super(), this.autoplay = "true" === this.dataset.autoplay, this.loop = "true" === this
        .dataset.loop, this.background = "true" === this.dataset.background, this.naturalWidth =
        "true" === this.dataset.naturalWidth
    }
    connectedCallback() {
      this.init()
    }
    init() {
      let e = this.dataset.videoUrl;
      e ? e.includes("youtu.be") || e.includes("youtube.com") ? (e.includes("v=") ? this.videoId =
          e.split("v=").pop().split("&")[0] : this.videoId = e.split("?")[0].split("/").pop(),
          this.type = "youtube", this.initYouTube()) : e.includes("vimeo.com") && (this.videoId =
          e.split("?")[0].split("/").pop(), this.type = "vimeo", this.initVimeo()) : (this.type =
          "tag", this.initVideoTag()), this.background && this.closest(".video-section")
        .addEventListener("click", this.play.bind(this))
    }
    loadScript(e) {
      if (document.querySelector(`script[src="${e}"]`)) return;
      let t = document.createElement("script");
      t.src = e, t.onerror = t => console.warn(`Unable to load script ${e}`, t), "vimeo" === this
        .type ? t.onload = () => document.dispatchEvent(new CustomEvent("on:vimeo-api:loaded")) :
        "youtube" === this.type && (window.onYouTubeIframeAPIReady = () => document.dispatchEvent(
          new CustomEvent("on:youtube-api:loaded"))), document.body.appendChild(t)
    }
    initYouTube() {
      let e = () => {
        YT.ready(() => {
          this.player = new YT.Player(this.querySelector("div"), {
            videoId: this.videoId,
            width: "1280",
            height: "720",
            playerVars: {
              controls: this.background ? 0 : 1,
              disablekb: this.background ? 1 : 0,
              iv_load_policy: 3,
              modestbranding: 1,
              playsinline: 1,
              rel: 0
            },
            events: {
              onReady: this.handleYTReady.bind(this),
              onStateChange: this.handleYTStateChange.bind(this)
            }
          })
        })
      };
      window.YT ? e() : (document.addEventListener("on:youtube-api:loaded", e.bind(this)), this
        .loadScript("//www.youtube.com/iframe_api"))
    }
    initVimeo() {
      let e = async () => {
        this.player = new Vimeo.Player(this, {
          id: this.videoId,
          width: "1280",
          height: "720",
          autoplay: this.autoplay,
          background: this.background,
          keyboard: !this.background,
          muted: this.autoplay,
          loop: this.loop
        }), await this.player.ready(), this.setupIframe("js-vimeo"), this.player.on("pause",
          () => {
            this.inViewport && (this.pausedByUser = !0)
          }), this.player.on("play", () => {
          this.closest(".video-section").classList.add("video-section--played")
        }), this.play()
      };
      window.Vimeo ? e() : (document.addEventListener("on:vimeo-api:loaded", e.bind(this)), this
        .loadScript("//player.vimeo.com/api/player.js"))
    }
    initVideoTag() {
      if (this.player = this.querySelector("video"), this.player.addEventListener("pause", () => {
          this.inViewport && (this.pausedByUser = !0)
        }), this.player.currentTime > 0 && !this.player.paused && !this.player.ended && this
        .player.readyState > 2) this.closest(".video-section").classList.add(
        "video-section--played");
      else {
        this.player.addEventListener("play", () => {
          this.closest(".video-section") && this.closest(".video-section").classList.add(
            "video-section--played")
        }), this.addObserver(this.player);
        let e = this.closest("deferred-media");
        e && "click" === e.loadTrigger || (this.player.muted = !0), this.play()
      }
    }
    handleYTReady() {
      this.setupIframe("js-youtube"), this.autoplay && this.player.mute(), this.play()
    }
    handleYTStateChange(e) {
      e.data === YT.PlayerState.PAUSED ? this.inViewport && (this.pausedByUser = !0) : e.data ===
        YT.PlayerState.ENDED ? this.background && this.player.playVideo() : e.data === YT
        .PlayerState.PLAYING && this.closest(".video-section").classList.add(
          "video-section--played")
    }
    setupIframe(e) {
      this.autoplay && !this.naturalWidth && (this.style.width = `${1.7778*this.clientHeight}px`,
          window.addEventListener("resize", window.debounce(() => {
            this.style.width = `${1.7778*this.clientHeight}px`
          }, 200))), this.iframe = this.querySelector("iframe"), this.iframe.title = this.dataset
        .description, this.iframe.classList.add(e), this.addObserver(this.iframe)
    }
    play() {
      this.player && !this.pausedByUser && ("youtube" === this.type ? this.player.playVideo() :
        this.player.play())
    }
    pause() {
      this.player && ("youtube" === this.type ? 2 !== this.player.getPlayerState() && (this.player
          .pauseVideo(), this.pausedByUser = !1) : "vimeo" === this.type ? this.player
        .getPaused().then(e => {
          e || (this.player.pause(), this.pausedByUser = !1)
        }) : this.player.paused || (this.player.pause(), this.pausedByUser = !1))
    }
    addObserver(e) {
      if ("IntersectionObserver" in window == !1) return;
      let t = new IntersectionObserver(e => {
        e.forEach(e => {
          e.isIntersecting ? (this.inViewport = !0, this.play()) : (this.inViewport = !1,
            this.pause())
        }, {
          rootMargin: "0px 0px 200px 0px"
        })
      });
      t.observe(e)
    }
  }
  customElements.define("video-component", e)
}
